// @flow

const CASCADE_POLICY_TYPE_AI_EXTRACT = 'ai_extract';
const TEMPLATE_CUSTOM_PROPERTIES: 'properties' = 'properties';
const ENHANCED_AGENT_CONFIGURATION = 'enhanced_extract_agent';
const STANDARD_AGENT_ID = '1';
const ENHANCED_AGENT_ID = '2';

export {
    CASCADE_POLICY_TYPE_AI_EXTRACT,
    TEMPLATE_CUSTOM_PROPERTIES,
    ENHANCED_AGENT_CONFIGURATION,
    STANDARD_AGENT_ID,
    ENHANCED_AGENT_ID,
};
